import { ChamberMember, CodebookModel, FileWrapper } from 'app/shared/model/shared.model';
import { LegalEntityModel, PersonModel } from 'app/shared/oib/oib.model';
import { AddressModel, initialAddress } from 'app/shared/address-input/model/address.model';

export interface CaseTechnicalInspectionModel {
  technicalInspectionCost: string;
  technicalInspectionNote: string;
}

export interface FinalReportOfSupervisingEngineerViewModel {
  idFinalReport: number;
  finalReportType: string;
  workType: string;
  supervisingEngineer: string;
  buildingDiaryCode: string;
  mark: string;
  reportDate: Date;
  hasAttachment: boolean;
}

export interface WrittenStatementViewModel {
  idWrittenStatement: number;
  writtenStatementType: string;
  workType: string;
  siteConstructor: string;
  buildingDiaryCode: string;
  mark: string;
  statementDate: Date;
  hasAttachment: boolean;
}

export interface FinalReportOfSupervisingEngineerModel {
  idFinalReport?: number;
  finalReportType: CodebookModel[];
  workType: CodebookModel[];
  mark: string;
  reportDate: Date;
  fileWrapper: FileWrapper;
  multipartFile: File;
  supervisingEngineer: ChamberMember;
}

export interface WrittenStatementModel {
  idWrittenStatement?: number;
  writtenStatementType: CodebookModel[];
  workType: CodebookModel[];
  mark: string;
  statementDate: Date;
  fileWrapper: FileWrapper;
  multipartFile: File;
  subjectType: CodebookModel[];
  person: PersonModel;
  legalEntity: LegalEntityModel;
  siteConstructorAddress: AddressModel;
  chiefConstructionEngineer: ChamberMember;
}

export const finalReportOfSupervisingEngineerInitial = {
  finalReportType: [],
  workType: [],
  mark: '',
  reportDate: '',
  fileWrapper: null,
  multipartFile: null,
  supervisingEngineer: {
    authorizationNumber: [],
    oib: '',
  },
};

export const writtenStatementInitial = {
  writtenStatementType: [],
  workType: [],
  mark: '',
  statementDate: '',
  fileWrapper: null,
  multipartFile: null,
  subjectType: [],
  siteConstructorAddress: initialAddress,
  person: {
    oib: '',
    firstName: '',
    lastName: '',
    dateOfBirth: null,
    address: null,
    subjectType: null,
  },
  legalEntity: {
    oib: '',
    mb: '',
    address: null,
    companyName: '',
    subjectType: null,
  },
  chiefConstructionEngineer: {
    authorizationNumber: [],
    oib: '',
  },
};

export const technicalInspectionInitial = {
  technicalInspectionCost: '',
  technicalInspectionNote: '',
};
